import React, { Component } from "react";
import { Send, SlidersHorizontal, Search, X, MoreVertical, ChevronLeft, ChevronRight } from "lucide-react";
import ShowMessageIntent from "./ShowMessageIntent";
import CustomizeAndMoreInformation from "./CustomizeAndMoreInformation";
import MessageHistory from "./MessageHistory";
import CustomizeAIResponse from "./CustomizeAIResponse";
import MessageSentSuccess from "./MessageSentSuccess";
import MessageBroadCastStatus from "./MessageBroadCastStatus";
import { withRouterHooks } from "../../../../withRouters/withRoutersHook";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  FetchAllMessagesForOverview,
  addMessageToRedux,
  resetSendMessageRedux,
  QueueAIResponse,
  BroadCastQueuedMessages,
  resetBroadCastMessagesStatus,
} from "../../../../Actions/Messaging";

class Messaging extends Component {
  state = {
    activeCustomizeIndex: null,
    isShowMessageIntentActive: false,
    isShowMessageHistory: false,
    isShowAIResponse: false,
    phone_number: "",
    message: "",
    messageSentSuccess: false,
    showBroadcastMessageStatus: false,
    searchTerm: "",
    currentPage: 1,
    pageInput: "1",
    broadcastError: null,
  };

  static propTypes = {
    FetchAllMessagesForOverview: PropTypes.func.isRequired,
    addMessageToRedux: PropTypes.func.isRequired,
    resetSendMessageRedux: PropTypes.func.isRequired,
    QueueAIResponse: PropTypes.func.isRequired,
    BroadCastQueuedMessages: PropTypes.func.isRequired,
    resetBroadCastMessagesStatus: PropTypes.func.isRequired,
    allOverviewChatSessions: PropTypes.array,
    allOverviewChatSessionsFetchSuccess: PropTypes.bool,
    allOverviewChatSessionsTotalPages: PropTypes.number,
    messageSent: PropTypes.bool,
    messageSuccessfullybroadcasted: PropTypes.bool,
  };

  // Create a ref for the search input
  searchInputRef = React.createRef();

  componentDidMount() {
    this.props.FetchAllMessagesForOverview(this.state.currentPage);

    // Mount keyboard shortcut listener
    document.addEventListener("keydown", this.handleGlobalKeyDown);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.messageSent &&
      this.props.messageSent !== prevProps.messageSent
    ) {
      this.handleMessageSentSuccess();
    }
    // if (
    //   this.props.messageSuccessfullybroadcasted &&
    //   this.props.messageSuccessfullybroadcasted !==
    //     prevProps.messageSuccessfullybroadcasted
    // ) {
    //   this.setState({ showBroadcastMessageStatus: false });
    // }
  }

  componentWillUnmount() {
    // Remove keyboard shortcut listener
    document.removeEventListener("keydown", this.handleGlobalKeyDown);
  }

  handleGlobalKeyDown = (e) => {
    // Ctrl/Cmd + F to focus search
    if ((e.ctrlKey || e.metaKey) && e.key === "f") {
      e.preventDefault();
      this.focusSearch();
    }
  };

  handleCustomize = (index) => {
    // Toggle dropdown for the selected item
    this.setState((prevState) => ({
      activeCustomizeIndex:
        prevState.activeCustomizeIndex === index ? null : index,
    }));
  };

  closeCustomize = () => {
    this.setState({ activeCustomizeIndex: null });
  };

  showMessageIntent = (number) => {
    this.setState({ isShowMessageIntentActive: true });
    this.setState({ activeCustomizeIndex: null });
    this.setState({ phone_number: number });
  };

  closeShowMessageIntent = () => {
    this.setState({ isShowMessageIntentActive: false });
    this.setState({ isShowMessageHistory: false });
  };

  showMessageHistory = () => {
    this.setState({ isShowMessageHistory: true });
    this.setState({ isShowMessageIntentActive: false });
  };

  closeShowMessageHistory = () => {
    this.setState({ isShowMessageHistory: false });
  };

  backToMessageIntent = (message) => {
    this.setState({
      isShowMessageHistory: false,
      isShowMessageIntentActive: true,
      isShowAIResponse: false,
      ...(message && { message: message }),
    });
  };

  showAIResponse = (number, message) => {
    this.setState({
      phone_number: number,
      isShowAIResponse: true,
      isShowMessageIntentActive: false,
      ...(message && { message: message }),
    });
  };

  addPhoneNumberToState = (phone_number) => {
    this.setState({ phone_number });
  };

  closeShowAIResponse = () => {
    this.setState({ isShowAIResponse: false });
  };

  navigateToMessage = (number) => {
    window.location.assign(`/#/dashboard/message-overview/whatsapp/${number}`);
  };

  handleMessageTruncate = (message) => {
    const maxLength = 20;

    // Guard against null/undefined
    if (!message) return "";

    // If the message is longer than the max, truncate and add '...'
    if (message.length > maxLength) {
      return message.substring(0, maxLength) + "...";
    }

    // Otherwise, return as is
    return message;
  };

  addMessageToState = (message) => {
    this.props.addMessageToRedux(message);
  };

  handleMessageSentSuccess = () => {
    this.setState({ messageSentSuccess: true });

    setTimeout(() => {
      this.setState({ messageSentSuccess: false });
      this.props.resetSendMessageRedux();
    }, 1500);
  };

  handleQueueBroadcast = (phone_number) => {
    this.props.QueueAIResponse(phone_number);
    setTimeout(() => {
      this.props.FetchAllMessagesForOverview(this.state.currentPage);
    }, 1000);
  };

  handlePageChange = (page) => {
    if (page >= 1 && page <= (this.props.allOverviewChatSessionsTotalPages || 1)) {
      this.setState({ currentPage: page, pageInput: String(page) }, () => {
        this.props.FetchAllMessagesForOverview(page);
      });
    }
  };

  handlePageInputChange = (e) => {
    this.setState({ pageInput: e.target.value });
  };

  handlePageInputSubmit = (e) => {
    if (e.key === "Enter") {
      const page = parseInt(this.state.pageInput, 10);
      const totalPages = this.props.allOverviewChatSessionsTotalPages || 1;
      if (!isNaN(page) && page >= 1 && page <= totalPages) {
        this.handlePageChange(page);
      } else {
        this.setState({ pageInput: String(this.state.currentPage) });
      }
      e.target.blur();
    }
  };

  handlePageInputBlur = () => {
    const page = parseInt(this.state.pageInput, 10);
    const totalPages = this.props.allOverviewChatSessionsTotalPages || 1;
    if (!isNaN(page) && page >= 1 && page <= totalPages) {
      this.handlePageChange(page);
    } else {
      this.setState({ pageInput: String(this.state.currentPage) });
    }
  };

  handleShowBroadcastMessageStatus = async () => {
    this.setState({ showBroadcastMessageStatus: true });

    const result = await this.props.BroadCastQueuedMessages();

    // Backend returns { results: [...] } — if nothing was sent, show error instead
    if (result?.results?.length === 0) {
      this.setState({ showBroadcastMessageStatus: false, broadcastError: "No messages are queued. Use the Queue option on a row first." });
      setTimeout(() => this.setState({ broadcastError: null }), 4000);
      return;
    }

    setTimeout(() => {
      this.setState({ showBroadcastMessageStatus: false });
    }, 3000);

    setTimeout(() => {
      this.props.resetBroadCastMessagesStatus();
      this.props.FetchAllMessagesForOverview(this.state.currentPage);
    }, 4000);
  };

  // Handle search input changes
  handleSearchInputChange = (e) => {
    this.setState({ searchTerm: e.target.value });
  };

  // Handle keyboard events for search
  handleSearchKeyDown = (e) => {
    // Press Escape to clear search
    if (e.key === "Escape") {
      this.handleClearSearch();
    }

    // Press Enter to focus on first result (if any)
    if (e.key === "Enter" && this.getFilteredMessages().length > 0) {
      // Could add functionality to select first result
      e.preventDefault();
    }
  };

  // Focus the search input
  focusSearch = () => {
    if (this.searchInputRef.current) {
      this.searchInputRef.current.focus();
    }
  };

  // Filter messages based on search term
  getFilteredMessages = () => {
    const { searchTerm } = this.state;
    const messages = this.props.allOverviewChatSessions || [];

    if (!searchTerm.trim()) {
      return messages; // Return all messages if search term is empty
    }

    const lowerCaseSearchTerm = searchTerm.toLowerCase();

    return messages.filter((item) => {
      // Search in customer name/phone number
      const customerMatch = (item.user_name || item.phone_number || "")
        .toLowerCase()
        .includes(lowerCaseSearchTerm);

      // Search in message content
      const messageMatch = (item.unread_message?.body || "")
        .toLowerCase()
        .includes(lowerCaseSearchTerm);

      // Search in AI response
      const aiResponseMatch = (item.ai_response || "")
        .toLowerCase()
        .includes(lowerCaseSearchTerm);

      // Return true if any of the fields match
      return customerMatch || messageMatch || aiResponseMatch;
    });
  };

  // Clear search input
  handleClearSearch = () => {
    this.setState({ searchTerm: "" });
  };

  render() {
    const filteredMessages = this.getFilteredMessages();
    const { searchTerm, currentPage, broadcastError, pageInput } = this.state;
    const totalPages = this.props.allOverviewChatSessionsTotalPages || 1;

    return (
      <div className="relative w-full h-full flex flex-col">
        {/* Overlays */}
        {this.state.isShowMessageIntentActive && (
          <ShowMessageIntent
            closeShowMessageIntent={this.closeShowMessageIntent}
            showMessageHistory={this.showMessageHistory}
            showAIResponse={this.showAIResponse}
            message={this.state.message}
            phone_number={this.state.phone_number}
          />
        )}
        {this.state.isShowMessageHistory && (
          <MessageHistory
            closeShowMessageHistory={this.closeShowMessageHistory}
            closeShowMessageIntent={this.closeShowMessageIntent}
            backToMessageIntent={this.backToMessageIntent}
            phone_number={this.state.phone_number}
          />
        )}
        {this.state.isShowAIResponse && (
          <CustomizeAIResponse
            closeShowAIResponse={this.closeShowAIResponse}
            backToMessageIntent={this.backToMessageIntent}
            phone_number={this.state.phone_number}
            message={this.state.message}
            handleMessageSentSuccess={this.handleMessageSentSuccess}
          />
        )}
        {this.state.showBroadcastMessageStatus && <MessageBroadCastStatus />}
        {this.state.messageSentSuccess && <MessageSentSuccess />}

        {/* Scrollable body */}
        <div
          className="flex flex-col w-full flex-1 px-4 md:px-8 min-h-0 overflow-y-auto"
          style={{
            background:
              "radial-gradient(ellipse at top left, #dbeafe 0%, transparent 50%), radial-gradient(ellipse at top right, #e0e7ff 0%, transparent 50%), radial-gradient(ellipse at bottom center, #eff6ff 0%, transparent 60%), #f8faff",
          }}
        >

          {/* Header */}
          <div className="flex flex-col gap-3 pt-6 md:pt-8 pb-4">
            {/* Title + Send Queue */}
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <button
                  onClick={() => this.props.navigate("/dashboard")}
                  className="p-1.5 rounded-md text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-colors"
                  aria-label="Back"
                >
                  <ChevronLeft className="w-5 h-5" />
                </button>
                <h1 className="font-SFPro font-bold text-2xl text-gray-900 whitespace-nowrap">All Messages</h1>
              </div>
              <button
                onClick={this.handleShowBroadcastMessageStatus}
                className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-gradient-to-r from-primary-blue to-blue-400 text-white text-sm font-medium hover:from-blue-600 hover:to-blue-500 transition-all duration-150 font-inter shadow-sm"
              >
                <Send className="w-4 h-4" />
                Send Queue
              </button>
            </div>

            {/* Broadcast error */}
            {broadcastError && (
              <div className="flex items-center gap-2 px-4 py-3 bg-amber-50 border border-amber-200 rounded-lg text-sm font-inter text-amber-700">
                <span>{broadcastError}</span>
              </div>
            )}

            {/* Search */}
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-3">
                <div className="relative flex-1">
                  <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
                  <input
                    ref={this.searchInputRef}
                    type="text"
                    placeholder="Search customer, message or AI response"
                    className="w-full h-10 pl-9 pr-9 border border-gray-200 rounded-lg text-sm font-inter text-gray-900 outline-none focus:border-primary-blue transition-colors"
                    value={searchTerm}
                    onChange={this.handleSearchInputChange}
                    onKeyDown={this.handleSearchKeyDown}
                  />
                  {searchTerm && (
                    <button
                      onClick={this.handleClearSearch}
                      className="absolute right-3 top-1/2 -translate-y-1/2"
                      aria-label="Clear search"
                    >
                      <X className="w-4 h-4 text-gray-400 hover:text-gray-600" />
                    </button>
                  )}
                </div>
                <button className="flex items-center justify-center w-10 h-10 border border-gray-200 rounded-lg bg-gradient-to-r from-gray-50 to-gray-100 hover:from-gray-100 hover:to-gray-200 transition-all duration-150 shrink-0">
                  <SlidersHorizontal className="w-4 h-4 text-gray-500" />
                </button>
              </div>
              {searchTerm && (
                <p className="text-xs text-gray-500 px-1">
                  {filteredMessages.length === 0
                    ? `No results for "${searchTerm}"`
                    : `${filteredMessages.length} ${filteredMessages.length === 1 ? "result" : "results"} for "${searchTerm}"`}
                </p>
              )}
            </div>
          </div>

          {/* Table */}
          <div className="flex-1 bg-white border border-blue-100 rounded-xl flex flex-col">
            {/* Title bar */}
            <div className="px-6 py-4 border-b border-blue-100 rounded-t-xl" style={{ background: "linear-gradient(135deg, #ffffff 0%, #eff6ff 100%)" }}>
              <p className="font-inter font-semibold text-sm text-gray-700 uppercase tracking-wider">Conversations</p>
            </div>
            {/* Column headers */}
            <div className="grid grid-cols-12 items-center py-2 bg-gray-50/50 px-5 gap-4 border-b border-gray-100">
              <div className="col-span-3 text-xs font-medium text-gray-400 uppercase tracking-wider">Customer</div>
              <div className="col-span-3 text-xs font-medium text-gray-400 uppercase tracking-wider">Message</div>
              <div className="col-span-3 text-xs font-medium text-gray-400 uppercase tracking-wider">AI Response</div>
              <div className="col-span-1 text-center text-xs font-medium text-gray-400 uppercase tracking-wider">Status</div>
              <div className="col-span-2 text-center text-xs font-medium text-gray-400 uppercase tracking-wider">Actions</div>
            </div>

            {/* Rows */}
            <div className="flex-1">
              {filteredMessages.length > 0 ? (
                filteredMessages.map((item, index) => (
                  <div
                    key={index}
                    className="grid grid-cols-12 px-5 py-3.5 gap-4 border-t border-gray-100 font-inter text-sm text-gray-700 hover:bg-blue-50/40 transition-colors items-center"
                  >
                    {/* Customer */}
                    <div className="col-span-3">
                      <p className="font-medium text-gray-900 truncate">{item.user_name || item.phone_number}</p>
                      <p className="text-xs text-gray-400 mt-0.5 italic">No platform info</p>
                    </div>

                    {/* Message */}
                    <button
                      onClick={() => this.navigateToMessage(item.phone_number)}
                      className="col-span-3 text-left"
                    >
                      <p className="text-sm text-blue-600 hover:text-blue-700 line-clamp-2">
                        {this.handleMessageTruncate(item.unread_message?.body)}
                      </p>
                    </button>

                    {/* AI Response */}
                    <button
                      onClick={() => this.showAIResponse(item.phone_number, item.unread_message?.body)}
                      className="col-span-3 text-left"
                    >
                      <p className={`text-sm line-clamp-2 ${
                        item.ai_response === "NA" || !item.ai_response
                          ? "text-gray-400 italic"
                          : "text-blue-600 hover:text-blue-700"
                      }`}>
                        {item.ai_response === "NA" || !item.ai_response
                          ? "Not available"
                          : this.handleMessageTruncate(item.ai_response)}
                      </p>
                    </button>

                    {/* Status */}
                    <div className="col-span-1 flex justify-center">
                      <span className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium border ${
                        item.queued_for_broadcast === true
                          ? "bg-blue-50 text-blue-700 border-blue-100"
                          : item.unread_message?.read === false
                          ? "bg-purple-50 text-purple-700 border-purple-100"
                          : "bg-gray-50 text-gray-600 border-gray-100"
                      }`}>
                        <span className={`w-1.5 h-1.5 rounded-full ${
                          item.queued_for_broadcast === true
                            ? "bg-blue-500"
                            : item.unread_message?.read === false
                            ? "bg-purple-500"
                            : "bg-gray-400"
                        }`} />
                        {item.queued_for_broadcast === true ? "Queued" : item.unread_message?.read === false ? "New" : "Read"}
                      </span>
                    </div>

                    {/* Actions */}
                    <div className="col-span-2 flex items-center justify-center">
                      <div className="relative">
                        <button
                          onClick={() => {
                            this.handleCustomize(index);
                            this.addPhoneNumberToState(item.phone_number);
                          }}
                          className="p-1.5 rounded-md text-gray-500 hover:bg-blue-50 hover:text-primary-blue transition-colors"
                        >
                          <MoreVertical className="w-4 h-4" />
                        </button>
                        {this.state.activeCustomizeIndex === index && (
                          <div className="absolute right-0 top-8 z-20">
                            <CustomizeAndMoreInformation
                              ShowMessageIntent={this.showMessageIntent}
                              phone_number={item.phone_number}
                              message={item.unread_message?.body}
                              queued_for_broadcast={item.queued_for_broadcast}
                              onQueueToggle={this.handleQueueBroadcast}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="flex flex-1 w-full flex-col items-center justify-center gap-6 py-12">
                  <div className="w-20 h-20 rounded-full flex items-center justify-center" style={{ background: "linear-gradient(135deg, #dbeafe 0%, #e0e7ff 100%)" }}>
                    {searchTerm
                      ? <Search className="w-10 h-10 text-blue-400" />
                      : <Send className="w-10 h-10 text-blue-400" />
                    }
                  </div>
                  <div className="text-center">
                    {searchTerm ? (
                      <>
                        <p className="text-lg font-semibold text-gray-600">No results found</p>
                        <p className="text-sm text-gray-400 mt-1">No matches for "{searchTerm}"</p>
                        <button
                          onClick={this.handleClearSearch}
                          className="mt-4 flex items-center gap-1.5 px-3 py-1.5 mx-auto rounded-lg bg-gradient-to-r from-primary-blue to-blue-400 text-white text-sm font-medium hover:from-blue-600 hover:to-blue-500 transition-all duration-150 font-inter shadow-sm"
                        >
                          Clear search
                        </button>
                      </>
                    ) : (
                      <>
                        <p className="text-lg font-semibold text-gray-600">No messages yet</p>
                        <p className="text-sm text-gray-400 mt-1">Messages will appear here once received</p>
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Pagination */}
          <div className="mt-auto pt-4 pb-6 flex justify-between items-center">
            <button
              onClick={() => this.handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
            >
              <ChevronLeft className="w-4 h-4" />
              Previous
            </button>

            <div className="flex items-center gap-2 text-sm text-gray-600 font-medium">
              <span>Page</span>
              <input
                type="text"
                value={pageInput}
                onChange={this.handlePageInputChange}
                onKeyDown={this.handlePageInputSubmit}
                onBlur={this.handlePageInputBlur}
                onFocus={(e) => e.target.select()}
                className="w-12 h-9 text-center border border-gray-200 rounded-lg text-sm font-medium text-gray-900 outline-none focus:border-primary-blue transition-colors"
              />
              <span>of {totalPages}</span>
            </div>

            <button
              onClick={() => this.handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
            >
              Next
              <ChevronRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  allOverviewChatSessions: state.messaging.allOverviewChatSessions,
  allOverviewChatSessionsFetchSuccess:
    state.messaging.allOverviewChatSessionsFetchSuccess,
  allOverviewChatSessionsTotalPages:
    state.messaging.allOverviewChatSessionsTotalPages,
  messageSent: state.messaging.messageSent,
  messageSuccessfullybroadcasted:
    state.messaging.messageSuccessfullybroadcasted,
});

export default withRouterHooks(
  connect(mapStateToProps, {
    FetchAllMessagesForOverview,
    addMessageToRedux,
    resetSendMessageRedux,
    QueueAIResponse,
    BroadCastQueuedMessages,
    resetBroadCastMessagesStatus,
  })(Messaging)
);
